// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"370":"5fde1bce","4110":"2188e4ea","8465":"2188e4ea"}[chunkId] + ".chunk.css";
};